import React from 'react'
import search_t from '../../../img/search_t.png'
import home_t_nav from '../../../img_3/class.png'
import close from '../../../img_3/close.png'
import icon_share from '../../../img/share.png'
import Searchbar from '../Searchbar/Searchbar'
import './Hearde.css'
import hostName from '../../../method/hostname'

export default function Hearde({ cataname, top_list, setsear, searflag, setSearch, flag, setshare }) {
  const caseTransform = () => {
    let nStr = '' + cataname[0].toUpperCase()
    return nStr + cataname.substr(1)
  }
  return (
    <div className="t_head">
      <img src={flag ? close : home_t_nav} alt="" onClick={top_list} className="t_nav" />
      <div className="icons">
        <img src={search_t} alt="" onClick={setsear} className="t_search" />
        <img src={icon_share} alt="" onClick={setshare} className="shareIcon" />
      </div>
      <h1> {window.location.pathname === '/' ? hostName : caseTransform()}</h1>
      <Searchbar searflag={searflag} setsear={setsear} setSearch={setSearch}></Searchbar>
    </div>
  )
}
